module.exports = __webpack_public_path__ + "img/4_140.dc332210.png";